import { Card, CardContent, TextField } from "@material-ui/core";
import CardTitle from "@saleor/components/CardTitle";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import FormSpacer from "@saleor/components/FormSpacer";
import SingleAutocompleteSelectField, {
  SingleAutocompleteChoiceType
} from "@saleor/components/SingleAutocompleteSelectField";
import { CountryErrorFragment } from "@saleor/fragments/types/CountryErrorFragment";
import { ChangeEvent } from "@saleor/hooks/useForm";
import { commonMessages } from "@saleor/intl";
import { FetchMoreProps } from "@saleor/types";
import { getFormErrors } from "@saleor/utils/errors";
import getCountryErrorMessage from "@saleor/utils/errors/country";
import React from "react";
import { useIntl } from "react-intl";

import { CountryPageFormData } from "../CountryPage/CountryPage";

export interface CountryDetailsProps {
  data: CountryPageFormData;
  disabled: boolean;
  errors: CountryErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
  defaultCurrency: string;
  defaultLanguage: string;
  languages: SingleAutocompleteChoiceType[];
  fetchLanguages: (data: string) => void;
  fetchMoreLanguages: FetchMoreProps;
  onLanguageChange: (event: ChangeEvent) => void;
  currencyrates: SingleAutocompleteChoiceType[];
  onCurrencyChange: (event: ChangeEvent) => void;
  fetchCurrencyrates: (data: string) => void;
  fetchMoreCurrencyrates: FetchMoreProps;
}

const CountryDetails: React.FC<CountryDetailsProps> = ({
  data,
  disabled,
  errors,
  onChange,
  defaultCurrency,
  defaultLanguage,
  languages,
  fetchLanguages,
  fetchMoreLanguages,
  onLanguageChange,
  fetchCurrencyrates,
  fetchMoreCurrencyrates,
  onCurrencyChange,
  currencyrates
}) => {
  const intl = useIntl();
  const formErrors = getFormErrors(
    ["name", "isoTwoCode", "isoThreeCode", "isoNumberCode"],
    errors
  );
  return (
    <Card>
      <CardTitle
        title={intl.formatMessage(commonMessages.generalInformations)}
      />
      <CardContent>
        <TextField
          disabled={disabled}
          error={!!formErrors.name}
          label={intl.formatMessage({
            defaultMessage: "Country Name",
            description: "Country Name"
          })}
          name={"name" as keyof CountryPageFormData}
          fullWidth
          helperText={getCountryErrorMessage(formErrors.name, intl)}
          value={data.name}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.isoTwoCode}
          label={intl.formatMessage({
            defaultMessage: "ISO Two Code",
            description: "ISO TWO CODE"
          })}
          name={"isoTwoCode" as keyof CountryPageFormData}
          fullWidth
          helperText={getCountryErrorMessage(formErrors.isoTwoCode, intl)}
          value={data.isoTwoCode}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.isoThreeCode}
          label={intl.formatMessage({
            defaultMessage: "ISO Three Code",
            description: "ISO Three Code"
          })}
          name={"isoThreeCode" as keyof CountryPageFormData}
          fullWidth
          helperText={getCountryErrorMessage(formErrors.isoThreeCode, intl)}
          value={data.isoThreeCode}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.isoNumberCode}
          label={intl.formatMessage({
            defaultMessage: "ISO　Number　Code",
            description: "ISO　Number　Code"
          })}
          name={"isoNumberCode" as keyof CountryPageFormData}
          fullWidth
          helperText={getCountryErrorMessage(formErrors.isoNumberCode, intl)}
          value={data.isoNumberCode}
          onChange={onChange}
        />
        <FormSpacer />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Display Order",
            description: "Display Order"
          })}
          name={"displayOrder" as keyof CountryPageFormData}
          fullWidth
          value={data.displayOrder}
          onChange={onChange}
        />
        <FormSpacer />
        <SingleAutocompleteSelectField
          displayValue={defaultLanguage}
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Default Language"
          })}
          choices={disabled ? [] : languages}
          name="defaultLanguage"
          fetchChoices={fetchLanguages}
          onChange={onLanguageChange}
          value={disabled ? null : data.defaultLanguage?.languageCode}
          {...fetchMoreLanguages}
        />
        <FormSpacer />
        <SingleAutocompleteSelectField
          displayValue={defaultCurrency}
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Default Currency"
          })}
          choices={disabled ? [] : currencyrates}
          name="defaultCurrency"
          fetchChoices={fetchCurrencyrates}
          onChange={onCurrencyChange}
          value={disabled ? null : data.defaultCurrency?.code}
          {...fetchMoreCurrencyrates}
        />
        <FormSpacer />
        <ControlledCheckbox
          name={"enable" as keyof CountryPageFormData}
          label={intl.formatMessage({
            defaultMessage: "isEnable",
            description: "enable"
          })}
          checked={data.enable}
          onChange={onChange}
          disabled={disabled}
        />
        <FormSpacer />
      </CardContent>
    </Card>
  );
};
export default CountryDetails;
